<template>
<div>
    <h1 v-if="showModuleDropdownMenu" id="module_dropdown" :class="['app-heading', 'pointer', { live: getOpenDropdown == moduleName }, { 'no-navigation': !$slots.navigation }]" @click="updateOpenDropdown(moduleName)">
        <div :class="['hamburger', { open: getOpenDropdown == moduleName }]" v-if="$slots.navigation">
            <div class="layer layer-1"></div>
            <div class="layer layer-2"></div>
            <div class="layer layer-3"></div>
        </div>
        &nbsp;<slot name="programName"></slot>&nbsp;
        <svg class="angle" width="14" height="21" xmlns="http://www.w3.org/2000/svg" version="1.1">
            <line x1="1" x2="12" y1="3" y2="11" stroke="black" stroke-width="3" stroke-linecap="round"/>
            <line x1="12" x2="1" y1="11" y2="19" stroke="black" stroke-width="3" stroke-linecap="round"/>
        </svg>
        {{ routeName }}
    </h1>
    <transition name="slide" v-if="$slots.navigation">
        <div class="module-menu" v-if="getOpenDropdown == moduleName" :id="moduleName + '_dropdown'">
            <div class="module-menu-inner">
                <div class="module-menu-heading">
                    <div class="hamburger open module-menu-close" @click="updateOpenDropdown(moduleName)">
                        <div class="layer layer-1"></div>
                        <div class="layer layer-2"></div>
                        <div class="layer layer-3"></div>
                    </div>
                    <div>{{ getCustomModuleName }}</div>
                </div>
                <slot name="navigation"></slot>
                <slot name="settings"></slot>
            </div>
        </div>
    </transition>

    <div :class="[ $route.path == '/login' || $route.path == '/reset-password' ? 'container-login' : 'container', moduleName, $route.fullPath == '/range-memberships/range-manager' ? 'range-manager' : '' ]" :id="moduleName">
        <loading v-if="getLoadingModule.length > 0"></loading>
        <router-view v-else />
    </div>

    <!-- <offline-log-books v-if="moduleName == 'logbooks' && $route.path.indexOf('customer-4473') < 0"></offline-log-books> -->
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//import OfflineLogBooks from '@/modules/logbooks/components/OfflineLogBooks.vue'
export default {
    name: 'component-module',
    components: {
        //'offline-log-books': OfflineLogBooks
    },
    props: {
        moduleName: {
            type: String,
            required: true
        },
        hideNav: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    created() {
        if (typeof this.bootstrapModule == 'function') {
            this.bootstrapModule()
        }
    },
    computed: {
        ...mapState({
            getLoadingModule(state, getters) {
                return getters[this.moduleName + '/getLoadingModule']
            },
            getNavMenu(state, getters) {
                return getters[this.moduleName + '/getNavMenu']
            }
        }),
        showModuleDropdownMenu() {
            if (this.$route.path.indexOf('customer-4473') > -1 || this.hideNav) {
                return false
            }
            // TODO: use an attribute that informs if a module HAS a dashboard menu
            if (this.moduleName == 'dashboard_module') {
                return false
            }
            return true
        },
        routeName() {
            return (this.$route.name.indexOf('Dashboard') > -1) ? 'Dashboard' : this.getCustomRouteName || this.$route.name
        }
    },
    methods: {
        ...mapActions({
            bootstrapModule(dispatch, payload) {
                return dispatch(this.moduleName + '/bootstrapModule', payload)
            },
            updateLoadingModule(dispatch, payload) {
                return dispatch(this.moduleName + '/updateLoadingModule', payload)
            }
        }),
        notAllowed(menuItemId) {
            if (menuItemId in this.getMenuItemPolicies && this.getMenuItemPolicies[menuItemId].not_allowed) {
                return true
            }
            return false
        }
    }
}
</script>
